module.exports = __webpack_public_path__ + "7906fda26f09b3bfbe55e7c255a3f6fe.png";